import { render, staticRenderFns } from "./header-controls.vue?vue&type=template&id=6e7fb50c&scoped=true&"
import script from "./header-controls.vue?vue&type=script&lang=js&"
export * from "./header-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fb50c",
  null
  
)

export default component.exports